

















import { Component, Mixins, Prop } from "vue-property-decorator";
import { Point, Size } from "../../domain/drawing";
import { DragHandleMixin } from "./mixins";

@Component({
})
export default class MoveDragHandle extends Mixins(DragHandleMixin) {
  @Prop()
  toLocation: (s: Size) => Point;

  get location(): Point {
    return this.toLocation(this.handleSize);
  }

  get locationStyle(): any {
    return {
      left: this.location.x + "px",
      top: this.location.y + "px",
    };
  }
}
